import * as React from 'react';

import './countdown.style.scss';

import type { CountdownProps }          from './countdown.props';
import { calculateTimeLeft, parseDate } from './utils';

const Countdown: React.FC<CountdownProps> = function(props) {
  const {
          from,
          to,
        } = props;

  const { current: BLUE }     = React.useRef('#488ec8');
  const { current: RED }      = React.useRef('#dc1916');
  const { current: YELLOW }   = React.useRef('#ffc955');
  const { current: NULLABLE } = React.useRef('0д : 0ч : 0мин');

  const [timeLeft, setTimeLeft]               = React.useState(NULLABLE);
  const [backgroundColor, setBackgroundColor] = React.useState(BLUE);

  const update = React.useCallback(() => {
    const dateFrom = parseDate(from);
    const dateTo   = parseDate(to);

    if (!dateFrom || !dateTo) {
      setTimeLeft('');
      setBackgroundColor('');
    } else {
      const targetDate     = dateFrom > dateTo ? dateFrom : dateTo;
      const totalDuration  = Math.abs(dateFrom - dateTo);
      const remainingTime  = targetDate - new Date().getTime();
      const percentageLeft = remainingTime / totalDuration * 1e2;

      if (percentageLeft <= 0) {
        setTimeLeft('0д : 0ч : 0мин');
        setBackgroundColor('');
      } else if (remainingTime < 24 * 60 * 60 * 1000) {
        setTimeLeft(calculateTimeLeft(targetDate));
        setBackgroundColor(RED);
      } else if (percentageLeft >= 50) {
        setTimeLeft(calculateTimeLeft(targetDate));
        setBackgroundColor(BLUE);
      } else {
        setTimeLeft(calculateTimeLeft(targetDate));
        setBackgroundColor(YELLOW);
      }
    }
  }, [from, to]);

  React.useEffect(() => {
    let interval: ReturnType<typeof setInterval> | null = setInterval(update, 1e3);

    update();

    return () => {
      if (interval) {
        clearInterval(interval);
      }

      interval = null;
    };
  }, []);

  if (timeLeft === NULLABLE) {
    return null;
  }

  return (
    <div
      className={'countdown'}
      style={{ backgroundColor }}
    >{timeLeft}</div>
  );
};

export default Countdown;